export default __webpack_public_path__ + "static/media/lectureIcon.9e581183.svg";